import { IConfig } from '@cian/config/shared';

const DEFAULT_RESULTABLE_PRECISION = 7;

type TParams = {
  config: IConfig;
  isSinglePinExperimentActive: boolean;
  isDesktop: boolean;
  precision: number;
};

export function isResultablePrecision({ config, isSinglePinExperimentActive, isDesktop, precision }: TParams): boolean {
  const resultablePrecision =
    (isSinglePinExperimentActive && isDesktop && config.get<number>('mapSearchFrontend.resultablePrecision')) ||
    DEFAULT_RESULTABLE_PRECISION;

  return precision >= resultablePrecision;
}
